import { Button, Dropdown, Spin, Modal } from "antd";
import { useState } from "react";
import InfiniteTable from "../utils/InfiniteTable";
import {
  DeleteFilled,
  DownOutlined,
  EditFilled,
} from "@ant-design/icons";
import Moment from "react-moment";
import { useUserContext } from "../../contexts/UserContext";
import Toast from "../../helpers/Toast";
import { catchError } from "../../services/DaoService";
import { DepenseService } from "../../services/DepenseService";
import DepenseEditForm from "./DepenseEditForm";
import PropTypes from "prop-types";

const DepenseList = ({ paginationData, setPaginationData, depenses, setDepenses, searchParams, affaire, isReadOnly }) => {
  const { check } = useUserContext();
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [updateModalVisible, setUpdateModalVisible] = useState(false);
  const [selectedDepense, setSelectedDepense] = useState(null);

  const loadMore = () => {
    if (paginationData?.next_page_url) {
      setLoadingMore(true);
      DepenseService
        .post(paginationData.next_page_url, searchParams)
        .then((response) => {
          if (!response) {
            return;
          }
          setPaginationData(response.data);
          setDepenses(depenses => [...depenses, ...response.data.data]);
        })
        .catch((error) => {
          catchError(error);
        })
        .finally(() => {
          setLoadingMore(false);
        });
    }
  };
  const handleDelete = (idOrUid) => {
    setLoading(true);
    DepenseService.getInstance()
      .remove(idOrUid)
      .then((response) => {
        Toast.success(response.message);
        setDepenses((items) =>
          items.filter((item) => item.uid !== idOrUid)
        );
      })
      .catch((error) => {
        catchError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const openEditModal = (item) => {
    setSelectedDepense(item);
    setUpdateModalVisible(true);
  };

  const handleUpdate = (item) => {
    setDepenses(
      depenses => depenses.map((u) => (u.uid === item.uid ? item : u))
    );
    setSelectedDepense(null);
    setUpdateModalVisible(false);
  };

  const columns = [
    {
      title: "Désignation",
      dataIndex: "designation",
      key: "designation",
      width: 150,
    },
    {
      title: "Montant",
      dataIndex: "montant",
      key: "montant",
      width: 100,
      render: (montant) => (
        `${montant} ${affaire.monnaie.symbole}`
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => (
        date ? <Moment format="DD/MM/YYYY">{date}</Moment> : 'N/A'
      ),
      width: 70,
    },
    {
      title: "Commentaire",
      dataIndex: "commentaire",
      key: "commentaire",
      width: 150,
      ellipsis: true,
      render: (commentaire) => (
        commentaire ? commentaire : 'N/A'
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Dropdown
          menu={{
            items: [
              {
                key: 'edit',
                label: 'Modifier',
                icon: <EditFilled />,
                onClick: () => openEditModal(record)
              },
              {
                key: 'delete',
                label: 'Supprimer',
                icon: <DeleteFilled />,
                danger: true,
                onClick: () => {
                  Modal.confirm({
                    title: `Voulez-vous vraiment procéder à la suppression ?`,
                    okText: 'Confirmer',
                    cancelText: 'Annuler',
                    okType: 'danger',
                    onOk: () => handleDelete(record.uid)
                  });
                }
              }
            ].filter(item => {
              if (item.key === 'edit') return check('EDIT-DEPENSE') && !isReadOnly;
              if (item.key === 'delete') return check('DELETE-DEPENSE') && !isReadOnly;
              return true;
            })
          }}
        >
          <Button>
            Actions <DownOutlined />
          </Button>
        </Dropdown>
      ),
      width: 120,
      fixed: 'right'
    },

  ];

  return (
    <>
      <Spin spinning={loading}>
        <InfiniteTable
          rowKey={"uid"}
          dataSource={depenses}
          paginationData={paginationData}
          loadMore={loadMore}
          loading={loadingMore}
          columns={columns}
        />
      </Spin>
      {selectedDepense && (
        <DepenseEditForm
          visible={updateModalVisible}
          uid={selectedDepense.uid}
          onUpdate={handleUpdate}
          onCancel={() => setUpdateModalVisible(false)}
        />
      )}
    </>
  );
}
export default DepenseList;

DepenseList.propTypes = {
  paginationData: PropTypes.object.isRequired,
  searchParams: PropTypes.object,
  setPaginationData: PropTypes.func.isRequired,
  depenses: PropTypes.array.isRequired,
  setDepenses: PropTypes.func.isRequired,
  affaire: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
};